module.exports = __webpack_public_path__ + "static/media/14UNEP26.4b7e3efe.jpg";